import React from 'react';

interface State {
    error: Error | null;
}

/**
 * Evita que un error de renderizado deje la app en blanco: muestra un aviso
 * con opción de reintentar o recargar en lugar de desmontar todo el árbol.
 */
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('Error no controlado en la interfaz:', error, info.componentStack);
    }

    render() {
        if (!this.state.error) return this.props.children;

        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
                <div className="bg-white rounded-2xl shadow-lg border border-slate-200 p-8 max-w-md w-full text-center">
                    <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-2xl font-bold">!</div>
                    <h1 className="text-xl font-bold text-slate-800 mb-2">Algo salió mal</h1>
                    <p className="text-slate-500 text-sm mb-6">
                        Ocurrió un error inesperado en esta pantalla. Tus datos están guardados; puedes reintentar o recargar la aplicación.
                    </p>
                    <div className="flex gap-3 justify-center">
                        <button
                            onClick={() => this.setState({ error: null })}
                            className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-50 font-medium"
                        >
                            Reintentar
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            className="px-4 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700 font-medium"
                        >
                            Recargar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
